import { render } from "./SectionHeader.vue?vue&type=template&id=3e38d248&scoped=true&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "@/components/Shared/SectionHeader/style.scss?vue&type=style&index=0&id=3e38d248&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e38d248"]])

export default __exports__